import React, { Component } from 'react';
import TabControl from './TabControl.js';
import Consent from './pages/Consent.js';
import Debrief from './pages/Debrief.js';
import './App.css';



class App extends Component {

    constructor(props) {
        super(props);

        this.state = {
            page: 0
        }
    }

    handlePageFinished = () => {
        this.setState({ page: this.state.page += 1 });
    }

    render() {
        const {page} = this.state;
        return (
            <div className="App">
                {page === 0 && <Consent handlePageFinished={this.handlePageFinished} />}
                {page === 1 && <TabControl handlePageFinished={this.handlePageFinished} />}
                {page === 2 && <Debrief handlePageFinished={this.handlePageFinished} />}
            </div>
        );
    }
}

export default App;
